import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, FieldWrapper, FormField, Icon } from '@dixa/lib-shared-habla';
import { useFormContext, useWatch } from 'react-hook-form';
import { HookFormText } from 'components/hookForm';
/** A form field based on the strategy schema. */
export const SchemaField = ({ schema, disabled, hasFormValues, }) => {
    var _a;
    const { control, setValue } = useFormContext();
    const watchForm = useWatch({ control });
    const isEditing = (_a = watchForm[schema.key]) === null || _a === void 0 ? void 0 : _a.isEditing;
    if (hasFormValues && schema.secret && !isEditing) {
        return (_jsx(FormField, { children: _jsx(FieldWrapper, Object.assign({ disabled: disabled, label: schema.label }, { children: _jsx(Button, Object.assign({ variant: "secondary", slotStart: _jsx(Icon, { name: "pen" }), onClick: () => setValue(`${schema.key}.isEditing`, true) }, { children: "Click to set a new secret value" })) })) }, schema.key));
    }
    return (_jsx(FormField, { children: schema.type === 'string' ? (_jsx(HookFormText, { disabled: disabled, label: schema.label, name: `${schema.key}.value`, control: control, componentProps: Object.assign({ placeholder: `Insert ${schema.label}` }, (schema.secret &&
                isEditing && {
                prefix: {
                    type: 'button',
                    button: {
                        icon: 'arrow-left',
                        onClick: () => setValue(`${schema.key}.isEditing`, false),
                    },
                },
            })), rules: {
                required: {
                    value: schema.required,
                    message: 'This field is required',
                },
            } })) : (_jsxs(_Fragment, { children: ["This input type is currently not supported: ", schema.type, "."] })) }, schema.key));
};
